import { GetTransactionStatusResponse } from 'starknet'
import { getProvider } from '../../services/amm'
import { networkId } from '../../services/wallet.service'
import axios from 'axios'

export async function updateTx(txHash: string): Promise<GetTransactionStatusResponse | undefined> {
    const network = await networkId()
    if (!network) return undefined

    // const sequenceProvider = (await getSequencerProvider('mainnet-alpha')) as SequencerProvider
    const sequenceProvider2 = await getProvider(network)
    try {
        const res = (await sequenceProvider2.getTransactionReceipt(txHash)) as any
        return { tx_status: res.finality_status } as GetTransactionStatusResponse
    } catch (e) {
        return { tx_status: 'NOT_RECEIVED' } as GetTransactionStatusResponse
    }
}

export function isTransactionInProgress(transactionStatus: string): boolean {
    if (['REJECTED', 'PENDING', 'ACCEPTED', 'RECEIVED', 'FAILED', 'REJECTED'].some((s) => transactionStatus.includes(s))) {
        return false
    }
    return true
}

// https://iqmqf54z7ivmfru5x6xptowozm0bvmbl.lambda-url.us-east-1.on.aws/

export async function sendTxFailLog(txData: { sentTimestamp: number; failedTimeStamp: number; currentTick?: number; txHash: string; type: string; version: string }) {
    try {
        const response = await axios.post('https://iqmqf54z7ivmfru5x6xptowozm0bvmbl.lambda-url.us-east-1.on.aws/', txData)
    } catch (e) {
        console.log('Failed to send tx log')
    }
}
